export const rules = {
  name: [
    {
      required: true,
      message: '发货公司不能为空！',
      trigger: 'blur'
    }
  ]
}
